export const yAxis = [
  {
    labels: {
      format: '{value} A'
    },
    title: {
      text: 'Current'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value} V'
    },
    title: {
      text: 'Voltage'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value} kW'
    },
    title: {
      text: 'Power'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value} Hz'
    },
    title: {
      text: 'Frequency'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value} °C'
    },
    title: {
      text: 'Temperature'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value}'
    },
    title: {
      text: 'Fault/Status'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value} dBm'
    },
    title: {
      text: 'Signal Strength'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value} kWh'
    },
    title: {
      text: 'Energy'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value} %'
    },
    title: {
      text: 'Humidity'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value} %'
    },
    title: {
      text: 'Percentage'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value}'
    },
    title: {
      text: 'Hex'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value}'
    },
    title: {
      text: 'Decimal'
    },
    visible: false,
    opposite: true
  },
  {
    labels: {
      format: '{value} sec'
    },
    title: {
      text: 'Time'
    },
    visible: false,
    opposite: false
  },
  {
    labels: {
      format: '{value} PSI'
    },
    title: {
      text: 'Pressure'
    },
    visible: false,
    opposite: false
  }
];

export const relation = () => {
  const returnValue = {};
  for (let i = 0; i < yAxis.length; i++) {
    returnValue[yAxis[i].title.text] = i;
  }
  return returnValue;
};
